export default __webpack_public_path__ + "static/16_Cremated-01b962a90351156e29fc9c265bcc556a.pdf";